import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/greenEnergy',
    meta: { title: '绿色能源' },
    component: Layout,
    redirect: '/greenEnergy/list',
    children: [
      {
        path: 'list',
        meta: { title: '绿色能源', activeMenu: '/greenEnergy' },
        component: () => import('@/views/greenEnergy/GreenEnergy.vue')
      },
      {
        path: 'detail',
        meta: { title: '绿色能源详情', activeMenu: '/greenEnergy' },
        component: () => import('@/views/greenEnergy/GreenEnergyDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增绿色能源', activeMenu: '/greenEnergy' },
        component: () => import('@/views/greenEnergy/GreenEnergyAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑绿色能源', activeMenu: '/greenEnergy' },
        component: () => import('@/views/greenEnergy/GreenEnergyAdd.vue')
      }

    ]
  }

]
